module.exports = __webpack_public_path__ + "img/pop.1910aec.svg";